/** @format */

import {parseISO} from 'date-fns';

import {getMonthGenitive} from 'helpers/dateHelpers';

interface Options {
  startOn?: string;
  endOn: string;
}

const getPeriodDateText = ({startOn, endOn}: Options): string => {
  if (!startOn) {
    const parsed = parseISO(endOn);
    const monthString = getMonthGenitive(parsed.getMonth());
    return `${parsed.getDate()} ${monthString}`;
  }

  const parsedStart = parseISO(startOn);
  const parsedEnd = parseISO(endOn);

  const dayStart = parsedStart.getDate();
  const dayEnd = parsedEnd.getDate();

  const yearStart = parsedStart.getFullYear();
  const yearEnd = parsedEnd.getFullYear();

  const monthStart = parsedStart.getMonth();
  const monthEnd = parsedEnd.getMonth();

  const monthStartString = getMonthGenitive(monthStart);
  const monthEndString = getMonthGenitive(monthEnd);

  const includeYear = yearStart !== yearEnd;

  if (includeYear) {
    return `${dayStart} ${monthStartString} ${yearStart} - ${dayEnd} ${monthEndString} ${yearEnd}`;
  }

  const includeMonth = monthStart !== monthEnd;

  if (includeMonth) {
    return `${dayStart} ${monthStartString} - ${dayEnd} ${monthEndString}`;
  }

  return `${dayStart} - ${dayEnd} ${monthEndString}`;
};

export {getPeriodDateText};
